const PREMIUM_DIRECTION = 'PremiumUltra';

export const isPremiumUltra = (...args: any) =>
  [...args].flat().filter(Boolean).includes(PREMIUM_DIRECTION) ?? false;
